import { render } from "./CardReturn.vue?vue&type=template&id=6c8792c0&scoped=true"
import script from "./CardReturn.vue?vue&type=script&lang=js"
export * from "./CardReturn.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=6c8792c0&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=1&id=6c8792c0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8792c0"]])

export default __exports__